import {ErrorDetail} from "../api/config";
import {Alert} from "@mui/material";
import {errorConstants} from "../constants/ErrorConstants";

export default function ErrorDetailParser(props: {error?:  ErrorDetail | null }) {

    if (!props.error) {
        return <></>
    }

    const error = errorConstants.find(e => e.code === props.error.code)

    return <Alert severity='error'>
        {error?.message ?? 'خطای نا مشخص'}
    </Alert>
}
